import * as R from 'ramda';
import React from 'react';
import FormLabel from 'js/form_components/form_label';

export default function Input(props) {
    return (
        <div className="form-group">
            <FormLabel
                className={props.className}
                label={props.header}
                helpText={props.help}
                multiline
                inline
                place="right"
            />
            <input
                value={R.defaultTo('', props.value)}
                onChange={e => props.onChange(e.target.value)}
                placeholder={props.placeholder}
                className="input-sm form-control"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./form_components/form_input.js